import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";
import { ADDON_TITLE_CHAR_LIMIT } from "../constants";
import parseVenmoHandleFromUrl from "./parseVenmoHandleFromUrl";

const parseUrlForLabel = ({ url, variant }: { url?: string; variant?: AddonVariant }): string => {
	if (!url) return "";
	if (variant === AddonVariant.Venmo) {
		url = parseVenmoHandleFromUrl(url) ?? url;
	}

	const urlWithoutProtocol = url.replace(/(^\w+:|^)\/\//, "");
	return urlWithoutProtocol.length > ADDON_TITLE_CHAR_LIMIT
		? urlWithoutProtocol.slice(0, ADDON_TITLE_CHAR_LIMIT) + "..."
		: urlWithoutProtocol;
};
export default parseUrlForLabel;
